import React from 'react';
import './styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2024 Kalavaanya. Founded with love by Srujana & Sree Keerthi Valiveti.</p>
        <blockquote className="footer-quote">
          "Knowledge is the supreme wealth that increases by sharing" - Ancient Sanskrit Wisdom
        </blockquote>
      </div>
    </footer>
  );
};

export default Footer;